import Vue from 'vue'
import Vuex from 'vuex'
import api from '@/api'
import fileapi from '@/fileapi'

Vue.use(Vuex)


// Portal
const Portal_Module = {
  strict: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state: {
    account_id : '',
  },
  actions: {
    send_mail (state, payload) {
      let url = "/api/contact_mail/?application_type=" + payload.application_type + "&sendname=" + payload.sendname + "&email=" + payload.email + "&tel=" + payload.tel + "&url=" + payload.url + "&contents=" + payload.contents + "&resume_name=" + payload.resume_name + "&CV_name=" + payload.CV_name
      return api.get(url)
      .then(response =>{
        const tag = response
        return tag
      })
    },
    file_upload (state, payload) {
      const url = "/api/Application_file/"
      return fileapi.post(url, payload)
      .then(response => {
        const config = response.data
        return config
      })
    },
  }
}

const store = new Vuex.Store({
  modules: {
    Portal: Portal_Module,
  }
})

export default store